import { lazy } from "react";
import { RouteSuspense } from "@/shared/routing/RouteSuspense";
import type { RouteObject } from "react-router-dom";



const CouponsPage = lazy(() => import("@/modules/coupons/pages/CouponsPage").then(module => ({ default: module.CouponsPage })));
const DiscountsPage = lazy(() => import("@/modules/coupons/pages/DiscountsPage").then(module => ({ default: module.DiscountsPage })));
const FreeShippingPage = lazy(() => import("@/modules/coupons/pages/FreeShippingPage").then(module => ({ default: module.FreeShippingPage })));

export const couponsRoutes: RouteObject[] = [
  {
    path: "coupons",
    element: <RouteSuspense><CouponsPage /></RouteSuspense>,
  },
];

export const discountsRoutes: RouteObject[] = [
  {
    path: "discounts",
    element: <RouteSuspense><DiscountsPage /></RouteSuspense>,
  },
];

export const freeShippingRoutes: RouteObject[] = [
  {
    path: "free-shipping",
    element: <RouteSuspense><FreeShippingPage /></RouteSuspense>,
  },
];
